import { useMatchRoute, useNavigate } from 'react-location';
import useCurrentUser from 'src/hooks/core-api/useCurrentUser';

const OnboardingRedirect = () => {
  const currentUserQuery = useCurrentUser();
  const matchRoute = useMatchRoute();
  const navigate = useNavigate();
  const isOnboarding = matchRoute({ to: '/onboarding' });
  const isAwatingInstallation = matchRoute({ to: '/waiting-for-installation' });

  if (
    currentUserQuery.data &&
    currentUserQuery.data.onboarding_status === 'payment_information_required' &&
    !isOnboarding
  ) {
    console.log('Navigating to onboarding');
    navigate({ to: '/onboarding' });
  }

  if (
    currentUserQuery.data &&
    currentUserQuery.data.onboarding_status === 'awaiting_first_installation' &&
    !isAwatingInstallation
  ) {
    console.log('Navigating to awaiting installation');
    navigate({ to: '/waiting-for-installation' });
  }

  return <></>;
};

export default OnboardingRedirect;
